<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/budgetsubheads/edit">{{lang.LBL_ADD_SUBHEAD}}</router-link></li>
        <li><router-link to="/modules/budgetsubheads">{{lang.LBL_VIEW_SUBHEAD}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/BudgetSubHeads/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
        }
     },
     mounted() {
        this.lang = lang;
        let user = JSON.parse(localStorage.getItem('user_prefrence'));
            
    },
    methods:{
       
    }
}
</script>
